import * as Sentry from "@sentry/gatsby";

// From Sentry v8 the SDK is configured here rather than through the
// @sentry/gatsby plugin options in gatsby-config, which now only cover
// build-time concerns such as sourcemap upload.
const runtimeVersion =
  (process.env.GATSBY_COMMIT_REF
    ? process.env.GATSBY_COMMIT_REF.substring(0, 7)
    : undefined) || "development";

Sentry.init({
  dsn: "https://0d9d102ff3044950b35b5839f391f9b5@o552010.ingest.sentry.io/5723171",
  environment:
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development",
  release: runtimeVersion,
  sampleRate: 1,
});
